var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "word-search-tester-wrapper" },
    [
      _c(_setup.CInput, {
        staticClass: "w-25",
        attrs: {
          type: "number",
          min: 1,
          placeholder: "1",
          pattern: /^[1-9]\d*$/,
          disabled: _setup.disabled,
          label: "Element ID",
        },
        on: { input: _setup.updateElementId },
        model: {
          value: _setup.model.elementId,
          callback: function ($$v) {
            _vm.$set(_setup.model, "elementId", $$v)
          },
          expression: "model.elementId",
        },
      }),
      _vm._v(" "),
      _c(_setup.CInput, {
        staticClass: "flex-fill",
        attrs: { label: "Try typing words to use in Word Search" },
        model: {
          value: _setup.model.words,
          callback: function ($$v) {
            _vm.$set(_setup.model, "words", $$v)
          },
          expression: "model.words",
        },
      }),
      _vm._v(" "),
      _c(_setup.CButton, {
        staticClass: "ml-auto",
        attrs: {
          variant: "light",
          text: "Generate Word Search",
          disabled: !_setup.processedWords.length,
        },
        on: { click: _setup.generateWordSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }